import React, { useEffect, useState } from "react";
import { Carousel, ICarouselProps } from "@coherence-design-system/carousel";
import { Stack, StackItem } from "@fluentui/react";
import { ICustomerAddress } from "../../Common/Interfaces/ICustomerAddress";
import { ICustomerContact } from "../../Common/Interfaces/ICustomerContact";
import { Card } from "@coherence-design-system/controls";
import { CardStyles } from "./CarouselComponentStyle";
import { ICarouselComponentProps } from "./CarouselComponent.types";
import { stackTokensWithGap70 } from "../../QuotationStyle";
import { ADDRESS, CONTACT, SELECT_ACTION } from "../../Common/QuotationData";

const CarouselComponent: React.FunctionComponent<ICarouselComponentProps> = (
  props
) => {
  const { selectedKey, selection, setSelection, title } = props;
  const [selectedValue, setSelectedValue] = useState<string | undefined>(
    selectedKey
  );
  useEffect(() => {
    const handleDOMContentLoaded = () => {
      const scrollableContent = document.getElementsByClassName(
        "ms-Modal-scrollableContent"
      )[0];
      if (scrollableContent) {
        scrollableContent.setAttribute("role", "dialog");
        scrollableContent.setAttribute("aria-modal", "true");
        scrollableContent.setAttribute("aria-labelledby", "Edit details");
        scrollableContent.setAttribute("aria-label", "Edit details");
        scrollableContent.setAttribute("title", "Edit details");
      }
    };

    if (document.readyState === 'complete') {
      handleDOMContentLoaded();
  } else {
      document.addEventListener("DOMContentLoaded", handleDOMContentLoaded);
  }

    // Cleanup logic
    return () => {
      document.removeEventListener("DOMContentLoaded", handleDOMContentLoaded);
    };
  }, []); // Empty dependency array to run this effect only once

  const renderAddress = (address: ICustomerAddress, index: number) => {
    const completeAddress = `${address?.street} ${address?.city}, ${address?.state} ${address?.postalCode} ${address?.country} ${address?.addressTaxId}`;
    return (
      <Stack horizontal horizontalAlign="space-between" key={index + 1}>
        <StackItem style={{ margin: "2%", width: "auto" }}>
          <input
            type="radio"
            name="address"
            aria-label={`${SELECT_ACTION} ${ADDRESS} ${completeAddress}`}
            style={{ width: 20, height: 20 }}
            value={address.addressId}
            checked={selectedValue === address.addressId}
            onChange={(e) => {
              setSelectedValue(e.target.value);
              setSelection({
                ...selection,
                address,
              });
            }}
          />
        </StackItem>
        <StackItem>
          <p>{`${address?.name}`}</p>
          <p>{address?.street}</p>
          <p>
            {address?.city}, {address?.state} {address?.postalCode}
          </p>
          <p>{address?.country}</p>
          <p>{address?.addressTaxId}</p>
        </StackItem>
      </Stack>
    );
  };

  const getCustomerContacts = (contact: ICustomerContact, index: number) => {
    const completeContact = `${contact.contactFirstName} ${contact.contactLastName} ${contact.contactPhone} ${contact.contactEmail}`;
    return (
      <Stack horizontal horizontalAlign="space-around">
        <StackItem style={{ margin: "2%", width: "auto" }}>
          <input
            type="radio"
            name="contact"
            aria-label={`${SELECT_ACTION} ${CONTACT} ${completeContact}`}
            style={{ width: 20, height: 20 }}
            value={contact.id}
            checked={selectedValue === contact.id}
            onChange={(e) => {
              setSelectedValue(e.target.value);
              setSelection({
                ...selection,
                contact,
              });
            }}
          />
        </StackItem>
        <StackItem>
          <p>
            {contact.contactFirstName} {contact.contactLastName}
          </p>
          <p>{contact.contactPhone}</p>
          <p style={{ whiteSpace: "nowrap" }}>{contact.contactEmail}</p>
        </StackItem>
      </Stack>
    );
  };

  const getTitle = (): string => {
    const name = (
      <p
        style={{
          color: "rgb(0, 120, 212)",
          margin: "10px",
          fontWeight: "normal",
          fontSize: "15px",
        }}
        tabIndex={-1}
        aria-live="polite"
      >
        {props.title}
      </p>
    );
    return name as unknown as string;
  };

  const carouselProps: ICarouselProps = {
    items: props.items.map(
      (item: ICustomerContact | ICustomerAddress, index: number) => {
        return (
          <Stack
            horizontal
            horizontalAlign="space-between"
            style={{
              margin: "5%",
              paddingRight: "8%",
              height: "80%",
              width: "100%",
            }}
            key={index + 1}
            tokens={stackTokensWithGap70}
          >
            <Card styles={CardStyles}>
              <Stack horizontal horizontalAlign="space-between">
                {item?.hasOwnProperty("contactFirstName") &&
                item?.hasOwnProperty("contactLastName")
                  ? getCustomerContacts(item as ICustomerContact, index)
                  : renderAddress(item as ICustomerAddress, index)}
              </Stack>
            </Card>
          </Stack>
        );
      }
    ),
    title: getTitle(),
    responsive: true,
    itemWidth: 100,
    viewAllText: "",
    breakpoints: {
      xxxl: { width: 1805, items: 6 },
      xxl: { width: 1366, items: 5 },
      xl: { width: 1024, items: 4 },
      l: { width: 640, items: 3 },
      m: { width: 480, items: 2 },
      s: { width: 320, items: 1 },
    },
  };

  return <Carousel {...carouselProps} />;
};

export default CarouselComponent;
